export default {
	attributes: {
		design: 'basic',
		notifType: 'success',
		shadow: 3,
		columnBackgroundCustomSizeUnit: '%',
		columnTabletBackgroundCustomSizeUnit: '%',
		columnMobileBackgroundCustomSizeUnit: '%',
		dismissible: true,
		showIcon: false,
		title: 'Title for This Block',
		showTitle: true,
		titleLineHeightUnit: 'em',
		titleTabletLineHeightUnit: 'em',
		titleMobileLineHeightUnit: 'em',
		description: 'Description for this block. Use this space for describing your block. Any text will do.',
		showDescription: true,
		descriptionLineHeightUnit: 'em',
		descriptionTabletLineHeightUnit: 'em',
		descriptionMobileLineHeightUnit: 'em',
		showButton: true,
		buttonLineHeightUnit: 'em',
		buttonTabletLineHeightUnit: 'em',
		buttonMobileLineHeightUnit: 'em',
		buttonText: 'Button text',
		buttonNewTab: false,
		buttonDesign: 'ghost',
		uniqueClass: 'ugb-6ab4e13',
		hideDesktop: false,
		hideTablet: false,
		hideMobile: false,
		showBlockBackground: false,
		blockBackgroundBackgroundCustomSizeUnit: '%',
		blockBackgroundTabletBackgroundCustomSizeUnit: '%',
		blockBackgroundMobileBackgroundCustomSizeUnit: '%',
	},
}
